import type { Component } from "vue";

export const routes = [
  {
    path: "/marketplace/manage",
    name: "marketplace-manager",
    component: (): Promise<Component> => import("./views/MarketplaceManager.vue"),
    meta: {
      requiresAuth: true,
      requiredRoles: ["accountManager"],
      requiredGroups: [],
    },
  },
];
